import format from '../plugins/baseFormat';
import VueX from '../store';

export default class Store {
  constructor (initialData = {},) {
    const {
      _id,
      name,
      company_id,
      franchise_id,
      address,
      last_order,
      score,
      published,
      publish_status,
      financial_status,
      auto_dispatch,
      dispatch_type,
      dispatch_history,
      corporate_name,
      document_type_current,
      cnpj,
      cpf,
      inscricao_estadual,
      inscricao_municipal,
      tax_regime,
      responsible,
      cpf_validation,
      product_count,
      shipment_areas_count,
      last_invoices,
      orders,
      operating_hours,
      payment_methods,
      phone,
      info_for_driver,
      preparation_time,
      logistic_operator,
      attachments,
      company_uuid,
      company_list,
      bringg_team_id,
      store_deliveries,
      exclusive_online_payment,
      created_at,
      created_by,
      last_published_at,
      published_by,
      image,
    } = initialData;

    this._id = _id;
    this.bringg_team_id = bringg_team_id;
    this.name = name;
    this.company_id = company_id;
    this.franchise_id = franchise_id;
    this.address = address;
    this.last_order = last_order;
    this.score = score;
    this.published = published;
    this.publish_status = publish_status;
    this.financial_status = financial_status;
    this.auto_dispatch = auto_dispatch;
    this.dispatch_type = dispatch_type;
    this.dispatch_history = dispatch_history && dispatch_history.length ?
      dispatch_history.map((item,) => ({
        formatted_dispatch_type: {
          'POOL': 'Compartilhado',
          'DEDICATED': 'Dedicado',
        }[item.dispatch_type],
        formatted_create_date: format.dateFromNow(item.created_at,),
        formatted_update_date: format.dateFromNow(item.updatedAt,),
      }),) : [],
    this.address = address;
    this.corporate_name = corporate_name;
    this.document_type_current = document_type_current;
    this.exclusive_online_payment = exclusive_online_payment;
    this.cnpj = cnpj;
    this.cpf = cpf;
    this.inscricao_estadual = inscricao_estadual;
    this.inscricao_municipal = inscricao_municipal;
    this.tax_regime = tax_regime;
    this.responsible = responsible;
    this.cpf_validation = cpf_validation;
    this.product_count = product_count || 0;
    this.shipment_areas_count = shipment_areas_count || 0;
    this.store_deliveries = store_deliveries || 0;
    this.last_invoices = last_invoices || [];
    this.orders = orders || {};
    this.operating_hours = operating_hours || {};
    this.payment_methods = payment_methods || [];
    this.phone = phone;
    this.info_for_driver = info_for_driver;
    this.preparation_time = preparation_time;
    this.company_uuid = company_uuid;
    this.company_list = company_list;
    this.logisticOperator_id =
      logistic_operator && logistic_operator.value
        ? logistic_operator.value
        : undefined;
    this.attachments = (attachments || []).map((attachment,) => {
      return {
        ...attachment,
        formatted_status:
          attachment.status === 'APPROVED'
            ? 'Aprovado'
            : attachment.status === 'DISAPPROVED'
              ? 'Reprovado'
              : 'Pendente',
        name: `${attachment.attachment_type.split('_',)[0]}.${attachment.key.split('.',)[1]}`,
      };
    },);
    this.created_at = created_at ? format.date(created_at,) : undefined;
    this.created_by = created_by;
    this.last_published_at =
      last_published_at ? format.date(last_published_at,) : undefined;
    this.published_by = published_by;
    this.image = image;
  }

  set store (store,) {
    this._id = store._id;
    this.bringg_team_id = store.bringg_team_id;
    this.name = store.name;
    this.address = store.address;
    this.last_order = store.last_order;
    this.score = store.score;
    this.published = store.published;
    this.publish_status = store.publish_status;
    this.financial_status = store.financial_status;
    this.auto_dispatch = store.auto_dispatch;
    this.dispatch_type = store.dispatch_type;
    this.dispatch_history = store.dispatch_history && store.dispatch_history.length ?
      store.dispatch_history.map((item,) => ({
        formatted_dispatch_type: {
          'POOL': 'Compartilhado',
          'DEDICATED': 'Dedicado',
        }[item.dispatch_type],
        formatted_create_date: format.dateFromNow(item.created_at,),
        formatted_update_date: format.dateFromNow(item.updatedAt,),
      }),) : [],
    this.address = store.address;
    this.corporate_name = store.corporate_name;
    this.document_type_current = store.document_type_current;
    this.exclusive_online_payment = store.exclusive_online_payment;
    this.cnpj = store.cnpj;
    this.cpf = store.cpf;
    this.inscricao_estadual = store.inscricao_estadual;
    this.inscricao_municipal = store.inscricao_municipal;
    this.tax_regime = store.tax_regime;
    this.responsible = store.responsible;
    this.cpf_validation = store.cpf_validation;
    this.product_count = store.product_count || 0;
    this.store_deliveries = store.store_deliveries || 0;
    this.shipment_areas_count = store.shipment_areas_count || 0;
    this.last_invoices = store.last_invoices || [];
    this.orders = store.orders || {};
    this.operating_hours = store.operating_hours || {};
    this.payment_methods = store.payment_methods || [];
    this.phone = store.phone;
    this.info_for_driver = store.info_for_driver;
    this.preparation_time = store.preparation_time;
    this.company_uuid = store.company_uuid;
    this.company_list = store.company_list;
    this.logisticOperator_id =
      store.logistic_operator && store.logistic_operator.value
        ? store.logistic_operator.value
        : undefined;
    this.attachments = (store.attachments || []).map((attachment,) => {
      return {
        ...attachment,
        formatted_status:
          attachment.status === 'APPROVED'
            ? 'Aprovado'
            : attachment.status === 'DISAPPROVED'
              ? 'Reprovado'
              : 'Pendente',
        name: `${attachment.attachment_type.split('_',)[0]}.${attachment.key.split('.',)[1]}`,
      };
    },);
    this.created_at = store.created_at ? format.date(store.created_at,) : undefined;
    this.created_by = store.created_by;
    this.last_published_at =
      store.last_published_at ?
        format.date(store.last_published_at,) :
        undefined;
    this.published_by = store.published_by;
    this.image = store.image;
  }

  set orders (orders,) {
    this._orders = orders && orders.length ? orders.map((item,) => ({
      code: item.code || item.tracking_info.task_id,
      formatted_date: format.dateFromNow(item.created_at,),
      formatted_value: (() => {
        if (!item.delivery_form.price) {return '-';}
        return format.money(item.delivery_form.price,);
      })(),
      formatted_status: (() => ({
        ASSIGNED: 'Atribuído',
        CREATED: 'Não atribuído',
        ON_THE_WAY: 'A caminho',
        CHECKED_IN: 'Chegou ao destino',
        DONE: 'Concluído',
        NOT_USED: 'Status não usado',
        ACCEPTED: 'Aceito',
        CANCELED: 'Cancelado',
        REJECTED: 'Rejeitado',
        UNACKNOWLEDGED: 'Status desconhecido',
      }[item.tracking_info.tracking_status]))(),
    }),)
      : [];
  }

  get orders () {
    return this._orders;
  }

  get formatted_city_state () {
    return format.city_state({
      city: (this.address || {}).city,
      state: (this.address || {}).state,
    },);
  }

  get formatted_published () {
    return {
      true: 'Ativo',
      false: 'Inativo',
    }[this.published];
  }

  get formatted_last_order_date () {
    return format.dateFromNow(this.last_order,);
  }

  get formatted_score () {
    if (!this.score) {return '-';}

    return `#${this.score}`;
  }

  get formatted_product_count () {
    if (!this.product_count) {return 0;}

    return String(this.product_count,).padStart(2, '0',);
  }

  get formatted_shipment_areas_count () {
    if (!this.shipment_areas_count) {return 0;}

    return String(this.shipment_areas_count,).padStart(2, '0',);
  }

  get formatted_last_invoices () {
    return (this.last_invoices || []).map((invoice,) => {
      return {
        ...invoice,
        value: format.money(invoice.value,),
        due_date: format.
          utcDate(invoice.due_date,).
          format('DD/MM/YYYY',),
      };
    },);
  }

  get formatted_phone () {
    return format.phone(this.phone,);
  }

  get formatted_responsible_phone () {
    return format.phone((this.responsible || {}).phone,);
  }

  get formatted_cnpj () {
    return format.cnpj(this.cnpj,);
  }

  get formatted_cpf () {
    return format.cpf(this.cpf,);
  }

  get formatted_dispatch_type () {
    return this.dispatch_type === 'DEDICATED' ?
      'Dedicados' : this.dispatch_type === 'POOL' ? 'Compartilhados' : '-';
  }

  get toPost () {
    const newResponsible = { ...this.responsible, };
    newResponsible.phone = format.cleanPhone(newResponsible.phone,);
    return {
      address: {
        ...this.address,
        zipcode: format.cleanSymbols(this.address.zipcode,),
      },
      cnpj: format.cleanSymbols(this.cnpj,),
      cpf: format.cleanSymbols(this.cpf,),
      corporate_name: this.corporate_name,
      document_type_current: this.document_type_current,
      exclusive_online_payment: this.exclusive_online_payment,
      name: this.name,
      responsible: newResponsible,
      tax_regime: this.tax_regime,
      inscricao_estadual: this.inscricao_estadual,
      inscricao_municipal: this.inscricao_municipal,
      company_uuid: this.company_uuid,
      logisticOperator_id: this.logisticOperator_id || undefined,
      dispatch_type: this.dispatch_type,
      attachments: this.attachments.map((attachment,) => {
        // TODO: Testar apenas array com testes automatizados
        return {
          title: attachment.title,
          attachment_type: attachment.attachment_type,
          bucket: attachment.bucket,
          key: attachment.key,
          region: attachment.region,
        };
      },),
      franchise_id: VueX.getters['user/currentFranchise'],
    };
  }
}
